<div class="container">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div class="section-header">
        <pdq-heading element="h6">Display conditions</pdq-heading>
        <span class="section-subtitle">The extension only shows when these conditions are met.</span>
      </div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-rules-dynamic-form
          [formGroup]="formGroup"
          formArrayFieldName="restrictionsRules"
          [rules]="displayRules"
          [entities]="displayRulesEntities"
          [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
        <pdq-banner
          variant="info"
          bannerTitle="Eligibility at checkout"
          content="The widget only appears on checkouts that also qualify with Order Protection, such as a supported destination and shippable items."
          [closable]="false"></pdq-banner>
      </div>
    </div>
  </pdq-card>
</div>
